import React, { useEffect, useState } from 'react';
import { AccProfileSubFactorVO } from '@domain/vo/acca/v1/test/result/competence/AccProfileResultVO';
import classNames from 'classnames/bind';
import styles from './interviewQuestionGuides.module.scss';

const cx = classNames.bind(styles);

interface InterviewQuestionGuideProps {
  subFactors?: AccProfileSubFactorVO[] | null;
}

const InterviewQuestionGuide = ({ subFactors }: InterviewQuestionGuideProps) => {
  const [activeTab, setActiveTab] = useState<AccProfileSubFactorVO | null>(null);

  useEffect(() => {
    if (activeTab === null && subFactors) setActiveTab(subFactors[0]);
  }, []);

  if (!subFactors) return null;

  const getTabList = () => {
    const tabListEl = subFactors.map((accProfileSubFactor, index) => {
      const { keyword } = accProfileSubFactor;
      const isOn = activeTab === accProfileSubFactor;
      const handleClick = () => setActiveTab(accProfileSubFactor);

      return (
        <li key={index} className={cx('listItem')}>
          <a className={cx('tab', { active: isOn })} onClick={handleClick} role="button">
            {keyword}
          </a>
        </li>
      );
    });

    return <ul className={cx('tabList')}>{tabListEl}</ul>;
  };

  const getContentList = () => {
    const contentListEl = activeTab?.questions?.map((accProfileSubFactorQuestion, index) => {
      const { question, comment } = accProfileSubFactorQuestion;

      return (
        <li key={index} className={cx('listItem')}>
          <span className={cx('order')}>Q{index + 1}.</span>
          <div className={cx('qaWrapper')}>
            <em className={cx('question')}>{question}</em>
            <p className={cx('answer')}>{comment}</p>
          </div>
        </li>
      );
    });

    return <ol className={cx('contentList')}>{contentListEl}</ol>;
  };

  return (
    <div className={cx('wrapper')}>
      {getTabList()}
      {getContentList()}
    </div>
  );
};

export default InterviewQuestionGuide;
